import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTagBlocksStore } from "entities/modules/stores/useTagBlocksStore";
import React, { FC, Fragment } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import { COLOR_GREY_9, COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { AddIcon } from "shared/theme/icons/AddIcon";
import TagTypeItem from "./components/TagTypeItem";
import { StyledAddSection } from "./styled";

const ModuleTagsWidget: FC = () => {
  const { tagBlocks, addTagBlock } = useTagBlocksStore();

  return (
    <Stack spacing="1rem">
      {tagBlocks.map((block, index, items) => (
        <Fragment key={block.id}>
          <TagTypeItem
            key={block.id}
            id={block.id}
            tagType={block.tagType}
            primaryTagId={block.primaryTagId}
            selectedTags={block.selectedTags}
            deletable={items.length > 1}
          />
          {index !== items.length - 1 && (
            <Typography
              variant="bodyMMedium"
              color={COLOR_GREY_9}
              textAlign="center"
              fontWeight={600}
            >
              AND
            </Typography>
          )}
        </Fragment>
      ))}
      <ContentSection>
        <StyledAddSection onClick={addTagBlock}>
          <AddIcon color={COLOR_PRIMARY_MAIN} />
          <Typography
            variant="bodyMMedium"
            color={COLOR_PRIMARY_MAIN}
            ml="0.5rem"
          >
            Add Filter
          </Typography>
        </StyledAddSection>
      </ContentSection>
    </Stack>
  );
};

export default ModuleTagsWidget;
